import { render, staticRenderFns } from "./CertifiedReseller.vue?vue&type=template&id=14252e9c&scoped=true&"
import script from "./CertifiedReseller.vue?vue&type=script&lang=js&"
export * from "./CertifiedReseller.vue?vue&type=script&lang=js&"
import style0 from "./CertifiedReseller.vue?vue&type=style&index=0&id=14252e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14252e9c",
  null
  
)

export default component.exports